import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMixcloudComponent } from './simple-icons-mixcloud.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMixcloudComponent ],
    exports:      [ SimpleIconsMixcloudComponent ],
    bootstrap:    []
})
export class SimpleIconsMixcloudModule {}
